import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { useTranslation } from 'react-i18next';
import { WTableUsersRow } from './WTableUsersRow';

export function WTableUsers() {
  const { workspace_current, all_workspaces_users_map } = use_slice_workspace(['workspace_current', 'all_workspaces_users_map']);
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  function render_items() {
    let workspace_id = workspace_current._id;

    let users_map = all_workspaces_users_map.get_or_assert(workspace_id, { context: 'users_map' });

    const users = Array.from(users_map.values());

    return users.map(item => <WTableUsersRow key={item._id} item={item} />);
  }

  if (workspace_current.is_personal) return <></>;

  return (
    <div
      className={`${md(
        'h-[350px] min-h-[350px] w-full',
        ' max-h-[30vh] pt-2',
      )} mt-3  flex flex-col justify-center items-start  border-b border-component-border  text-page-foreground`}
    >
      <div className="text-xl">{t(i18n_page_settings_workspace.tabs.users.shared.table.users.title)}</div>
      <div
        className={`${md(
          ' px-2 justify-between',
          'gap-5 pr-5 justify-start',
        )} border-b border-component-border  w-full min-h-[50px] flex flex-row items-center    mt-2`}
      >
        <span className={`${md('w-[45px] text-[10px]', 'w-[100px]')}  text-center`}>
          {t(i18n_page_settings_workspace.tabs.users.shared.table.users.column.avatar)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[150px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.users.shared.table.users.column.name)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[200px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.users.shared.table.users.column.member_from)}
        </span>
        <span className={`${md('w-[55px] text-[10px]', 'w-[200px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.users.shared.table.users.column.last_online_at)}
        </span>
      </div>
      <div className="flex flex-col justify-start items-center h-full w-full overflow-auto">{render_items()}</div>
    </div>
  );
}
